const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL ?? '';

/**
 * prefix the dedicated application server url
 * defined by default over the `NEXT_PUBLIC_BACKEND_URL` environment variable
 */
export const prefixServerUrl = (url: string): string => url ? `${BACKEND_URL}${url}` : '';
